import React from 'react';
import Styled from 'styled-components';

function InfoMessages({ className }) {
  return (
    <div className={className}>
      <ul>
        <li>
          <span>
            If you are an ePRco user, please login from that site so you will not have to create
            another user-name and password.
          </span>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <span>If you are not an ePRco user, you can:</span>
        </li>
      </ul>
      <p className="padding-left-60">
        <span>
          <span>
            Click on “Create Dealer Account” which allows you to make a payment and to save your
            bank account information for future payments. For future payments, you will click the
            “Login” button.
          </span>
        </span>
      </p>
      <p className="padding-left-60">
        <span>
          Click on “Guest Payment” which allows you to make a payment without saving your bank
          account information.
        </span>
      </p>
      <p>&nbsp;</p>
      <p className="padding-x-30">
        <span>Questions? Call 1-800-969-7001 and ask for Ben or Mundo&nbsp;</span>
        <span>or click live chat below and ask for Alexis or Jen.</span>
      </p>
    </div>
  );
}

export default Styled(InfoMessages)`
margin-top: 1.3rem;
color: #454545; 
font-family: 'Helvetica Neue';
font-size: medium;
font-style: normal;
font-weight: normal;
font-size: 1.7rem;
  .padding-left-60 {
    padding-left: 60px;
  }
  .padding-x-30 {
    padding-left: 30px;
    padding-right: 30px;
  }
`;
